import type { GremlinQueryParams } from 'queries/queries-utils'

export const kubernetesQueryKeys = {
  getKubernetesTargetsKinds: (query: GremlinQueryParams) =>
    ['kubernetes/targets/kinds', query] as const
}

export const kubernetesMutationKeys = {
  getTargetsBySelector: (teamId: string) =>
    ['/kubernetes/targets/by-selector', { teamId }] as const
}
